import angular from 'angular';
import bannersManagementRouting from './banners-management-routing-module';
import BannersManagementComponent from './banners-management-component';

export default angular
  .module('banners-management', [
    bannersManagementRouting.name,
  ])
  .component('bannersManagement', new BannersManagementComponent());



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/banners/banners-management-module.js